import React from 'react';
import ReactDOM from 'react-dom/client';
import './_a7f1c9.css';
import A1b2c3x from './a1b2c3x';
import {BrowserRouter as Router} from 'react-router-dom';
import Botd from '@fingerprintjs/botd';
import {Routes, Route} from "react-router-dom";
import Ux7zq1 from './serco/ux7zq1';
import P9k2m4 from './serco/p9k2m4';
import R8t6s3 from './serco/r8t6s3';
import G4h1v0 from './serco/g4h1v0';
import D5n2c7 from './serco/d5n2c7';
import N3b8z6 from './serco/n3b8z6';
import V3w4x5r from './v3w4x5r';

const bluchis = ReactDOM.createRoot(document.getElementById('root'));
const magrass = ReactDOM.createRoot(document.getElementById('bluchis'));
const gitmonkey = ReactDOM.createRoot(document.getElementById('gitmonkey'));

bluchis.render(
  <React.StrictMode>
    <Router>
      <Routes> 

  <Route path="/dKx8Qm3Jt5Zn2Vo9Lp4Ys7Rw6Fi0Uc1Tb8Ng3Xh7Kr2Wv5Jm9Lo1Qz4Bn6Ft3Hp7" element={<Ux7zq1 />} />
  <Route path="/yQn6Lp2Xo4Kv9Jm1Ts7Fb3Wr8Ig5Nc0Zd2Uh9Pk6Vr4Mt1Jo8Lq5Xn3Bs7Fy6Hw4" element={<P9k2m4 />} />
  <Route path="/hZp5Xq8Lo1Kr6Jn3Vs9Ft2Mb7Yi4Wc0Tg3Uo8Nr6Vk2Lp5Jm7Qn1Xs9Bd4Fw6Ht2" element={<R8t6s3 />} />
  <Route path="/qWm7Vr3Lp9Xo2Jt5Ks8Fn1By4Ig6Nc0Uz3Hp8Tn7Vo1Lk5Jr9Qm2Xs4Bd6Fy7Ht5" element={<G4h1v0 />} />
  <Route path="/zNr4Xp7Lq1Jk5Vo2Ms9Ft8Wb3Yi6Tc0Un7Hr2Xo4Lp9Jm5Kv1Qs8Bd3Fw7Ht6Nz5" element={<D5n2c7 />} />
  <Route path="/vLp9Xo3Kr7Jn2Ms5Fb8Tq1Yi4Wc6No0Ug5Hr2Xp7Lk1Jm9Vt3Qs4Bd6Fy8Ht7Wz3" element={<N3b8z6 />} />

      </Routes>
    </Router>
  </React.StrictMode>
);

if (magrass) {
  magrass.render(
    <React.StrictMode>
      <Router>
        <Routes> 
          <Route path="/" element={<A1b2c3x />} />
           <Route path="/a1b2c3x" element={<A1b2c3x />} />
        </Routes>
      </Router>
    </React.StrictMode>
  );
}

if (gitmonkey) {
  gitmonkey.render(
    <React.StrictMode>
      <Router>
        <Routes> 
        <Route path="/abv" element={<ab />} />
        </Routes>
      </Router>
    </React.StrictMode>
  );
}
V3w4x5r();